<div class="col">
    <app-data-box [headerTitle]="titleFlight" [dataBoxItems]="dataItemFlight"></app-data-box>
     <app-data-box [headerTitle]="titleDeadhead" [dataBoxItems]="dataItemDeadhead"></app-data-box>
     <app-data-box [headerTitle]="titleTotal" [dataBoxItems]="dataItemTotal"></app-data-box>
     <app-data-box [headerTitle]="titleTAFB" [dataBoxItems]="dataItemTAFB"></app-data-box>
 </div>
